import React from "react";

const TermsAndConditions = () => {
  return (
    <div class="mt-32 mb-10 w-[90%] md:w-[50rem] mx-auto text-lg">
      <h1 class="subscription-font text-4xl font-medium text-[#262544] text-center mb-10">
        Terms and Conditions
      </h1>

      <div class="text-lg">
        Welcome to Deepnap Softech. By subscribing to and using our CRM
        services, you agree to be bound by these Terms and Conditions ("Terms").
        Please read them carefully before using our service.
      </div>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">1. Introduction</h2>
      <p class="text-lg">
        Deepnap Softech provides CRM (Customer Relationship Management) software
        on a subscription basis, allowing users to manage customer data, track
        leads, automate workflows, and enhance customer relations.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-2">
        1.1 Subscription Plans
      </h3>
      <p>
        Deepnap Softech offers various subscription plans with different
        features and pricing tiers. The details of each plan, including usage
        limits and pricing, are available on our website or as part of your
        subscription agreement.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">1.2 Free Trial</h3>
      <p>
        We may offer a free trial for a limited period for new users. After the
        trial period, you will be required to choose a paid plan to continue
        using the CRM services. If you do not upgrade, your access may be
        restricted.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">
        2. Account Registration
      </h2>
      <p>
        You must register for an account to use our CRM services. You agree to
        provide accurate and up-to-date information during the registration
        process and keep your account credentials secure.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">
        2.1 Account Responsibility
      </h3>
      <p>
        You are responsible for all activity under your account. Deepnap Softech
        is not liable for any loss or damage from unauthorized use of your
        account.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">
        3. Subscription Fees and Payments
      </h2>
      <p>
        Subscription fees are billed on a recurring basis, as per your selected
        plan (monthly or annually).
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-2">3.1 Payment Method</h3>
      <p>
        You agree to provide accurate billing information and authorize Deepnap
        Softech to charge your payment method for the recurring subscription
        fees.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">3.2 Late Payments</h3>
      <p>
        If your payment fails or is delayed, your account may be suspended or
        terminated until payment is received.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">3.3 Price Changes</h3>
      <p>
        Deepnap Softech reserves the right to modify the subscription fees with
        prior notice. Any changes will apply at the start of the next billing
        cycle.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">
        4. Cancellation and Refund Policy
      </h2>
      <p>
        You can cancel your subscription at any time from your account settings.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">4.1 Refunds</h3>
      <p>
        Subscriptions are non-refundable. If you cancel before the end of your
        current billing cycle, you will continue to have access to the CRM
        service until the cycle ends. No refunds will be given for unused
        periods.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">
        5. License and Use of Service
      </h2>
      <p>
        Deepnap Softech grants you a limited, non-exclusive, non-transferable
        license to use the CRM service for your business purposes.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">
        5.1 Prohibited Activities
      </h3>
      <p>You agree not to:</p>
      <ul class="list-disc pl-5">
        <li>Use the service for any illegal or unauthorized purpose.</li>
        <li>
          Reverse-engineer, decompile, or disassemble any part of the service.
        </li>
        <li>Share your account credentials with others.</li>
      </ul>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">
        6. Data Ownership and Privacy
      </h2>
      <p>You retain ownership of all data you enter into the CRM.</p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">6.1 Data Protection</h3>
      <p>
        Deepnap Softech follows industry-standard practices to protect your
        data. However, we cannot guarantee complete security and are not liable
        for data breaches outside of our control.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">6.2 Privacy Policy</h3>
      <p>
        By using our service, you agree to our Privacy Policy, which governs how
        we collect, use, and protect your data.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">
        7. Service Availability
      </h2>
      <p>
        We aim to provide continuous access to our CRM service but do not
        guarantee 100% uptime. There may be occasional downtime for maintenance
        or unforeseen issues.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">7.1 Support</h3>
      <p>
        Technical support is provided as part of your subscription plan. The
        level of support may vary based on your selected plan.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">
        8. Limitation of Liability
      </h2>
      <p>
        Deepnap Softech is not liable for any indirect, incidental, or
        consequential damages arising out of your use of the CRM service. Our
        total liability for any claim shall not exceed the amount you paid for
        the service in the last six months.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">9. Termination</h2>
      <p>
        Deepnap Softech reserves the right to terminate or suspend your access
        to the CRM service for any breach of these Terms.
      </p>

      <h3 class="text-xl font-bold text-[#262544] mt-1">
        9.1 Effect of Termination
      </h3>
      <p>
        Upon termination, your account will be deactivated, and your access to
        the CRM service will be revoked. Any outstanding payments will still be
        due.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">
        10. Changes to Terms
      </h2>
      <p>
        Deepnap Softech may modify these Terms from time to time. We will notify
        you of significant changes, and your continued use of the service will
        constitute acceptance of the updated Terms.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">11. Governing Law</h2>
      <p>
        These Terms are governed by the laws of Haryana (India). Any disputes
        arising from these Terms or your use of the service shall be resolved in
        the courts of Faridabad.
      </p>

      <h2 class="text-2xl font-bold text-[#262544] mt-4">12. Contact Us</h2>
      <p>
        For any questions or concerns regarding these Terms and Conditions,
        please contact us at{" "}
        <a href="mailto:deepnapsoftech@gmail.com" class="text-blue-500">
          deepnapsoftech@gmail.com
        </a>
        .
      </p>
    </div>
  );
};

export default TermsAndConditions;
